import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { FormateoFechaPara_yyyyMMdd, TratamientoDeParametroParaURI } from '../../Varios';
import { function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticulo, function_VEN_DocsVenta_Generar_JSON } from '../../VEN/DocsVenta/VEN_DocsVenta_Cabecera';

export const function_ABM_ART_Articulos_Reservables_AforoReservado_Listar = async (CodigoArticulo) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_AforoReservado_Listar"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_Reservables_AforoReservado/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables_AforoReservado_Generar_JSONBasico = async (codigoArticulo,
    horaDesde, horaHasta, cantidadReservada, vigenciaDesde, vigenciaHasta) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_AforoReservado_Generar_JSONBasico";

    const formatToTwoDigits = (number) => {
        return String(number).padStart(2, '0');
    };

    try {
        const JSONList = [];

        // Convertir horaDesde y horaHasta a objetos Date

        let currentHour = horaDesde;        
        const endHour = horaHasta;

        while (currentHour <= endHour) {
            const JSON = {
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoArticulo: codigoArticulo,
                Hora: formatToTwoDigits(currentHour) + ':00', // Convertir a formato HH:MM
                CantidadReservada: cantidadReservada,
                VigenciaDesde: await FormateoFechaPara_yyyyMMdd(vigenciaDesde),
                VigenciaHasta: await FormateoFechaPara_yyyyMMdd(vigenciaHasta)
            };

            JSONList.push(JSON);
            currentHour = currentHour + 1
        }

        const result = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            Registros: JSONList
        };

        return result;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables_AforoReservado_Eliminar = async (CodigoArticulo, VigenciaDesde, VigenciaHasta) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_AforoReservado_Eliminar"

    try {
        const resulData = await llamadaAPI_DELETE("ABM_ART_Articulos_Reservables_AforoReservado/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            VigenciaDesde + "/" +
            VigenciaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables_AforoReservado_Insertar = async (codigoArticulo,
    horaDesde, horaHasta, cantidadReservada, vigenciaDesde, vigenciaHasta) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_AforoReservado_Insertar";

    try {
        const Articulo = await llamadaAPI_POST("ABM_ART_Articulos_Reservables_AforoReservado/InsertarCompleto/",
            await function_ABM_ART_Articulos_Reservables_AforoReservado_Generar_JSONBasico(codigoArticulo,
                horaDesde, horaHasta, cantidadReservada, vigenciaDesde, vigenciaHasta));
        return Articulo;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};
